import React from 'react';
import { UserPlus, UserMinus } from 'lucide-react';

export const BulkReassignActions = ({ action, onChange, disabled }) => (
  <div className="flex gap-2 p-4 border-b border-slate-100" role="group" aria-label="Operación" data-testid="bulk-reassign-actions">
    {[['assign', 'Añadir usuario', UserPlus], ['remove', 'Quitar personas', UserMinus]].map(([value, label, Icon]) => (
      <button key={value} type="button" disabled={disabled} aria-pressed={action === value}
        onClick={() => onChange(value)} data-testid={`bulk-reassign-action-${value}`}
        className={`flex-1 flex justify-center items-center gap-2 px-2 py-2 text-xs font-medium rounded-md border transition-colors ${action === value ? 'border-blue-400 bg-blue-50 text-blue-700' : 'border-slate-200 text-slate-600 hover:bg-slate-50'}`}>
        <Icon className="w-4 h-4 shrink-0" />{label}
      </button>
    ))}
  </div>
);

export const BulkRemoveConfirmation = ({ label, userCount, assetCount, confirmed, onChange, disabled }) => (
  <div className="text-xs text-slate-700" data-testid="bulk-reassign-remove-details">
    {userCount > 0 ? <label className="flex items-start gap-2 cursor-pointer">
      <input type="checkbox" checked={confirmed} onChange={e => onChange(e.target.checked)} disabled={disabled}
        className="mt-0.5 accent-red-600 shrink-0" data-testid="bulk-reassign-remove-consent" />
      <span data-testid="bulk-reassign-remove-summary">Confirmo quitar {userCount} persona{userCount === 1 ? '' : 's'} de {label} en {assetCount} activo{assetCount === 1 ? '' : 's'}, conservando a las demás.</span>
    </label> : <p data-testid="bulk-reassign-remove-selection-count">0 personas seleccionadas</p>}
  </div>
);